// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1-0_c","approved":"Status_approved__W0T9W","rejected":"Status_rejected__1ZsMV","expired":"Status_expired__3-rBK","label":"Status_label__3-YAN"};